module.exports = require('./internal/FixedDataTableRoot');



// WEBPACK FOOTER //
// ../~/fixed-data-table/main.js